import { UserRoleDto } from '@/api/generated';
import { UsersListTranslation } from '@/assets/locales/views/usersList/usersList.translation.en.ts';

export const usersListTranslation: UsersListTranslation = {
  content: {
    dialog: {
      archiveAcceptedDevelopmentPaths: {
        button: {
          perform: 'Wykonaj',
        },
        endingText: 'Czy na pewno chcesz ją wykonać?',
        leadingText: 'Wykonanie tej akcji spowoduje:',
        pointsList: {
          first:
            "przesunięcie wszystkich zaakceptowanych Planów Rozwojowych do statusu 'Zarchiwizowane'.",
        },
      },
      getSsoUsersStats: {
        button: {
          download: 'Pobierz szczegóły o użytkownikach',
        },
      },
      sendEmailToVerifySso: {
        button: {
          confirm: 'Wyślij',
          send: 'Wyślij e-mail do weryfikacji konta',
        },
        content: {
          text: 'Ta akcja wyśle e-mail z prośbą o weryfikację konta w aplikacji do wszystkich nieaktywnych użytkowników. Czy na pewno chcesz kontynuować?',
        },
      },
    },
    table: {
      actions: 'Akcje',
      email: 'Email',
      enabled: 'Aktywne',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      resetPasswordButton: 'Reset hasła',
      role: {
        [UserRoleDto.Admin]: 'Administrator',
        [UserRoleDto.AdminCertification]: 'Administrator certyfikacji',
        [UserRoleDto.AdminDevelopment]: 'Administrator rozwoju',
        [UserRoleDto.AdminSuccession]: 'Administrator sukcesji',
        [UserRoleDto.Employee]: 'Pracownik',
        [UserRoleDto.Hrbp]: 'HRBP',
        [UserRoleDto.HrbpHq]: 'HRBP HQ',
        [UserRoleDto.ManagerP1]: 'Przełożony',
        [UserRoleDto.ManagerP2]: 'Przełożony P2',
      },
      roles: 'Role',
      rolesEmpty: 'Brak ról',
      sap: 'SAP',
      ssoCreated: 'SSO utworzone',
      verifiedInSso: 'Zweryfikowany w SSO',
    },
  },
  form: {
    button: {
      archiveAcceptedDevelopmentPaths: 'Archiwizacja planów rozwojowych',
      menu: {
        downloadTemplateFile: 'Pobierz plik wzorcowy',
      },
      uploadUsers: 'Wgraj użytkowników',
    },
    disabled: 'Nieaktywne',
    enabled: 'Aktywne',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    role: 'Rola',
    ssoCreated: 'SSO utworzone',
    ssoCreatedFalse: 'Nieutworzone',
    ssoCreatedTrue: 'Utworzone',
    verifiedInSso: 'Zweryfikowany w SSO',
    verifiedInSsoFalse: 'Niezweryfikowany',
    verifiedInSsoTrue: 'Zweryfikowany',
  },
};
